import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import Home from "./components/Home";
import "./App.css";
import { Routes, Route } from "react-router-dom";

const theme = extendTheme({
  styles: {
    global: () => ({
      body: {},
    }),
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <div className="full">
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </div>
    </ChakraProvider>
  );
}

export default App;
